import type { FeatureKey, FeatureRule, Platform } from '../../api/services/feature-rules'

export function defaultPlatformGate(key: FeatureKey) {
  return key === 'profileRedesign' || key === 'playerRedesign'
    ? { minVersion: '1.0.49', minBuildNumber: 1 }
    : { minVersion: '1.0.48', minBuildNumber: 0 }
}

export function prepareFeatureLaunch(key: FeatureKey, rule: FeatureRule): FeatureRule {
  const prepared = structuredClone(rule)
  prepared.enabled = true
  prepared.rolloutBasisPoints = 10000
  for (const platform of ['ios', 'android'] as const satisfies readonly Platform[]) {
    prepared.platforms[platform] ??= defaultPlatformGate(key)
  }
  return prepared
}

export function parseRolloutPercentage(value: string): number | null {
  if (!/^\d+$/.test(value)) return null
  const percentage = Number(value)
  return Number.isInteger(percentage) && percentage <= 100 ? percentage : null
}
